
const config = {
      context: '/v1',
    //context: ''
};


export default config
